import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import React from 'react';
import { AnalyticsTrigger, Anchor, Heading, Separator, Icon } from 'telia-front-react';
import { useStores } from '../../stores/RootStore';
import { CONTENT_CATEGORY } from '../../stores/SearchStore';
import { hasModifierKey } from '../../util/NavigationUtil';
import { WebContentFilterOrder, WebContentResult } from '../SearchInterfaces';
import SearchResultRow from './SearchResultRow';

interface Props {
  result: WebContentResult;
  onClick: (item: any) => void;
  contentClientTypeFilter: string;
}

const WebSearchResult = (props: Props) => {
  const { routeStore } = useStores();
  const { translate } = React.useContext(TranslationsContext);
  const { result, contentClientTypeFilter } = props;

  return (
    <SearchResultRow>
      <Heading element="h3" className="h4">
        {result.isPdfContent && (
          <span aria-label={translate('search.result.pdf')}>
            <Icon align="middle" modifiers="#file-pdf" />{' '}
          </span>
        )}
        <AnalyticsTrigger trigger={{ id: `Tab - ${CONTENT_CATEGORY} - Link - ${result.title || result.originalName}`, callback: 'onClick' }}>
          <Anchor
            url={result.url}
            isTextColor={true}
            className="text-weight-normal"
            onClick={(event) => {
              event.preventDefault();
              props.onClick(result);
              hasModifierKey(event) || result.isPdfContent ? window.open(result.url) : routeStore.push(result.url);
            }}
          >
            {result.title || result.originalName}
            {result.segment && contentClientTypeFilter === WebContentFilterOrder.ALL ? ` - ${translate(`search.clientType.${result.segment}`)}` : ''}
          </Anchor>
        </AnalyticsTrigger>
      </Heading>
      <div dangerouslySetInnerHTML={{ __html: result.content }} /> <Separator spacing="small" weight="thin" />
    </SearchResultRow>
  );
};

export default observer(WebSearchResult);
